import queryString from 'query-string';
import {
	CREATE_DATA,
	DELETE_DATA,
	DELETE_ROLEMANAGEMENT,
	GET_DATA_LIST,
	GET_DATA_USER,
	GET_IDENTIFY,
	GET_ROLES,
	GET_ROLES_LIST,
	SHARE_BUDGET_PLAN,
	UNSHARE_BUDGET_PLAN,
	UPDATE_DATA,
	UPDATE_ROLEMANAGEMENT,
	GET_MENU_LIST,
	GET_MENU_LIST_ALL,
} from '@/api/role';

const state = {
	list_data: [],
	list_user: [],
	roles: [],
	identify: {},
	mode: '',
};

const mutations = {
	SET_LIST_DATA: (states, payload) => {
		states.list_data = payload;
	},
	SET_LIST_USER: (states, payload) => {
		states.list_user = payload;
	},
	SET_ROLES: (states, payload) => {
		states.roles = payload;
	},
	SET_MENU: (states, payload) => {
		states.roles = payload;
	},
	SET_IDENTIFY: (states, payload) => {
		states.identify = payload;
	},

	SET_MODE: (states, payload) => {
		states.mode = payload;
	},
};

const actions = {
	GET_LIST_DATA: async ({ commit }, query) => {
		query = queryString.stringify(query);
		const resp = await GET_DATA_LIST(query);
		const data = resp.data.data;
		commit('SET_LIST_DATA', data);
	},
	GET_LIST_USER: async ({ commit }, query) => {
		query = queryString.stringify(query);
		const resp = await GET_DATA_USER(query);
		const data = resp.data.data;
		commit('SET_LIST_USER', data);
	},
	GET_ROLE: async ({ commit }, query) => {
		// query = queryString.stringify(query);
		const resp = await GET_ROLES();
		const data = resp.data.data;
		commit('SET_ROLES', data);
	},
	GET_IDENTIFY: async ({ commit }, query) => {
		// query = queryString.stringify(query);
		const resp = await GET_IDENTIFY();
		const data = resp.data.data;
		commit('SET_IDENTIFY', data);
	},
	CREATE_DATA: ({}, payload) => {
		return CREATE_DATA(payload);
	},
	DELETE_ROLEMANAGEMENT: ({}, payload) => {
		return DELETE_ROLEMANAGEMENT(payload);
	},
	UPDATE_ROLEMANAGEMENT: ({}, payload) => {
		return UPDATE_ROLEMANAGEMENT(payload);
	},

	DELETE_DATA: ({}, payload) => {
		return DELETE_DATA(payload);
	},
	UPDATE_DATA: ({}, payload) => {
		return UPDATE_DATA(payload);
	},
	SHARE_BUDGET_PLAN: ({}, payload) => {
		return SHARE_BUDGET_PLAN(payload);
	},
	UNSHARE_BUDGET_PLAN: ({}, payload) => {
		return UNSHARE_BUDGET_PLAN(payload);
	},
	GET_MENU_LIST: async ({ commit }, query) => {
		// query = queryString.stringify(query);
		const resp = await GET_MENU_LIST();
		const data = resp.data.data;
		commit('SET_LIST_DATA', data);
	},
	GET_MENU_LIST_ALL: async ({ commit }, query) => {
		// query = queryString.stringify(query);
		const resp = await GET_MENU_LIST_ALL();
		const data = resp.data.data;
		commit('SET_LIST_DATA', data);
	},
};

const getters = {
	listData: (states) => states.list_data,
	listUser: (states) => states.list_user,
	roles: (states) => states.roles,
	identity: (states) => states.identify,
	isSuperAdmin: (states) => states.identify?.roles_uenroll?.[0] == 'Super Admin',
	isAdmin: (states) => states.identify?.roles_uenroll?.[0] == 'Admin',
	isUser: (states) => states.identify?.roles_uenroll?.[0] == 'User',
	isViewer: (states) => states.identify?.roles_uenroll?.[0] == 'Viewer',
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
